import { Fragment } from 'react'
import StoryblokEditableComment from './storyblok/StoryblokEditableComment';

const NewsHeader = ({ component }) => {
  return (
    <>
      {' '} {component._editable && <StoryblokEditableComment text={component._editable} />}
      <header className="g-row news-header component component--visible">
        <h1 className="news-title">{component.title}</h1>
        <div className="t-mini c-gray">{component.date}</div>
      </header>
    </>
  );
};

export default NewsHeader;
